<script lang="ts">
	import ProfileInputFrame from "./ProfileInputFrame.svelte";
	import Editicon from "@hitit/hub/src/assets/Icons/Edit.png";
	export let name = "";
	export let value = "";
	export let editIcon = true;

</script>

<ProfileInputFrame name={name}>
	<div class="contents-container">
		<span class="value">{value}</span>
		{#if editIcon}<img src={Editicon} alt="Edit name" on:click />{/if}
	</div>
</ProfileInputFrame>

<style lang="scss">
	@import "../../../variables.scss";

	//Mobile First
	.contents-container {
		display: flex;
		flex-grow: 1;
		justify-content: space-between;
		align-items: center;
	}

	.value {
		color: #46474b;
		font-weight: 500;
	}
	img {
		width: 24px;
		height: 24.2px;
		&:hover {
			cursor: pointer;
		}
	}
	@include DesktopSize {
		.value {
			font-size: 1.25rem;
		}
	}

</style>
